import $ from 'jquery';
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
// import {
//   EmailShareButton,
//   TwitterShareButton,
//   FacebookShareButton,
//   LinkedinShareButton,
//   TelegramShareButton,
//   WhatsappShareButton,
//   PinterestShareButton,
//   InstapaperShareButton,
// } from 'react-share';
// import {
//   EmailIcon,
//   TwitterIcon,
//   FacebookIcon,
//   LinkedinIcon,
//   TelegramIcon,
//   WhatsappIcon,
//   PinterestIcon,
//   InstapaperIcon,
// } from 'react-share';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import Sidebar from './Sidebar';
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../helpers';
//hooks
import { useWindowSize } from '../../Hooks/use-window-size';
// mui
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';

const InnerAccountdetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const curr = Cookies.get('curr');
  const { width } = useWindowSize();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');

  // const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [accDetail, setAccDetail] = useState([]);
  const [jobDetail, setJobDetail] = useState([]);
  const [sendMail, setSendMail] = useState(false);
  const [userDetail, setUserDetail] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState([]);
  const [openCoverModal, setOpenCoverModal] = useState(false);
  const [mailReplyError, setMailReplyError] = useState({ subject: '', message: '' });
  const [mailUsers, setMailUsers] = useState({ job_id: '', subject: '', message: '' });

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + `/job/accdetail/${slug}`,
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      if (response.data.status === 200) {
        setLoading(false);
        setAccDetail(response.data.response);
        setJobDetail(response.data.response.jobInfo);
        setCandidates(response.data.response.candidates);
        setUserDetail(response.data.response.userDetails);
        setActiveOptions(response.data.response.active_option);
      } else if (response.data.status === 400) {
        navigate('/');

        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('employerFavouriteListProfile.close'));
      } else {
        Swal.fire({
          icon: 'error',
          text: response.data.message,
          confirmButtonText: t('employerFavouriteListProfile.close'),
          title: t('employerFavouriteListProfile.addFavFailedTitle'),
        });
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Could not get user data in inner account detail page', error);
    }
  };

  const handleCheckboxChange = email => {
    if (selectedEmails.includes(email)) {
      setSelectedEmails(prevSelectedEmails => prevSelectedEmails.filter(e => e !== email));
    } else {
      setSelectedEmails(prevSelectedEmails => [...prevSelectedEmails, email]);
    }

    setMailUsers({ ...mailUsers, job_id: jobDetail.job_id });
  };

  const handleGlobalCheckboxChange = () => {
    const allEmails = candidates.map(i => i.email_address);

    if (selectedEmails.length === allEmails.length) {
      setSelectedEmails([]);
    } else {
      setSelectedEmails(allEmails);
    }

    setMailUsers({ ...mailUsers, job_id: jobDetail.job_id });
  };

  const handleMailReplyChange = e => {
    const { name, value } = e.target;

    setMailUsers(prev => ({
      ...prev,
      [name]: value,
    }));

    setMailReplyError(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleMailReply = async () => {
    try {
      const newErrors = {};

      if (mailUsers.subject === '') {
        newErrors.subject = t('employerInnerAccountdetail.sujectRequired');
      }

      if (mailUsers.message === '') {
        newErrors.message = t('employerInnerAccountdetail.messageRequired');
      }

      setMailReplyError(newErrors);

      if (Object.keys(newErrors).length === 0) {
        const confirmationResult = await Swal.fire({
          icon: 'question',
          showCancelButton: true,
          cancelButtonText: t('employerInnerAccountdetail.no'),
          confirmButtonText: t('employerInnerAccountdetail.yes'),
          text: t('employerInnerAccountdetail.sendMailConfirmTxt'),
          title: t('employerInnerAccountdetail.sendMailConfirmTitle'),
        });

        if (confirmationResult.isConfirmed) {
          setLoading(true);

          const response = await axios.post(
            BaseApi + '/candidates/sendmailToalljobseekers',
            mailUsers,
            {
              headers: {
                key: ApiKey,
                token: tokenKey,
                contentType: 'application/json',
              },
            },
          );

          if (response.data.status === 200) {
            setLoading(false);

            resultInfo('success', t('employerInnerAccountdetail.sendMailSuccessTitle'), t('employerInnerAccountdetail.close'));

            setSendMail(false);
            setSelectedEmails('');
            setMailUsers({
              ...mailUsers,
              message: '',
              subject: '',
              email_address: [],
            });
          } else if (response.data.status === 400) {
            navigate('/');

            Cookies.remove('fname');
            Cookies.remove('user_id');
            Cookies.remove('user_type');
            Cookies.remove('tokenClient');

            resultInfo('warning', response.data.message, t('employerInnerAccountdetail.close'));
          } else {
            Swal.fire({
              icon: 'error',
              text: response.data.message,
              confirmButtonText: t('employerInnerAccountdetail.close'),
              title: t('employerFavouriteListProfile.addFavFailedTitle'),
            });
          }

          getData();
        }
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        resultInfo('error', t('employerInnerAccountdetail.sendMailFailedTitle'), t('employerInnerAccountdetail.close'));
      }

      console.error('Could not change password!', error);
    }
  };

  const handleSendButton = () => {
    if (selectedEmails.length === 0) {
      resultInfo('warning', t('employerInnerAccountdetail.selectMailEmptyTitle'), t('employerInnerAccountdetail.close')); // eslint-disable-line
    } else {
      setSendMail(true);
      setMailUsers({ ...mailUsers, email_address: selectedEmails.join(',') });
    }
  };

  const handleCancelClick = () => {
    setSendMail(false);
    setSelectedEmails('');
  };

  // const handleOpen = () => {
  //   // setSelectedPayment(plan);
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   // setSelectedPayment(null);
  //   setOpen(false);
  // };

  const handleOpenCoverModal = plan => {
    setSelectedPayment(plan);
    setOpenCoverModal(true);
  };

  const handleCloseCoverModal = () => {
    setSelectedPayment(null);
    setOpenCoverModal(false);
  };

  const handleStatusChange = async (id, value, userId) => {
    try {
      setLoading(true);

      await axios.post(
        BaseApi + `/job/accdetail/${slug}`,
        { candidate_id: id, status_change: value, user_id: userId },
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      getData();
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.error('Could not change status of user in inner account detail page.', error);
    }
  };

  const handleDelete = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: t('employerInnerAccountdetail.no'),
        confirmButtonText: t('employerInnerAccountdetail.yes'),
        text: t('employerInnerAccountdetail.deleteJobConfirmTxt'),
        title: t('employerInnerAccountdetail.deleteJobConfirmTitle'),
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/job/delete/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              token: tokenKey,
              contentType: 'application/json',
            },
          },
        );

        if (response.data.status === 200) {
          getData();

          navigate('/user/managejob');

          resultInfo('success', t('employerInnerAccountdetail.deleteJobSuccessTitle'), t('employerInnerAccountdetail.close')); // eslint-disable-line
        } else if (response.data.status === 400) {
          navigate('/');

          Cookies.remove('fname');
          Cookies.remove('user_id');
          Cookies.remove('user_type');
          Cookies.remove('tokenClient');

          resultInfo('warning', response.data.message, t('employerInnerAccountdetail.close'));
        } else {
          Swal.fire({
            icon: 'error',
            text: response.data.message,
            confirmButtonText: t('employerInnerAccountdetail.close'),
            title: t('employerFavouriteListProfile.addFavFailedTitle'),
          });
        }
      }
    } catch (error) {
      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        resultInfo('error', t('employerInnerAccountdetail.deleteJobFailedTitle'), t('employerInnerAccountdetail.close')); // eslint-disable-line
      }

      console.error('Could not delete the user in inner account detail page', error);
    }
  };

  const updateRating = async (val, id) => {
    try {
      await axios.post(
        BaseApi + `/job/updateRating/${id}/${val}`,
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );
    } catch (error) {
      console.error('Could not change user rating.');
    }
  };

  const handleStarClick = (event, val, id) => {
    var node = event.target;
    var allStarElement = node.parentNode.childNodes;

    allStarElement.forEach((element, index) => {
      if (index <= val) {
        $(element).removeClass('fa-regular');
        $(element).addClass('fa-solid');
        $(element).css('color', '#dde01f');
      } else {
        $(element).removeClass('fa-solid');
        $(element).addClass('fa-regular');
        $(element).css('color', '');
      }
    });

    updateRating(val + 1, id);
  };

  const renderStars = (rating, id) => {
    const stars = [];

    for (let j = 0; j < 5; j++) {
      if (j < rating) {
        const col = { color: '#dde01f' };

        stars.push(<i style={col} className='fa-solid fa-star' onClick={event => handleStarClick(event, j, id)} />);
      } else {
        stars.push(<i className='fa-regular fa-star' onClick={event => handleStarClick(event, j, id)} />);
      }
    }

    return stars;
  };

  const handleActivate = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: t('employerInnerAccountdetail.no'),
        confirmButtonText: t('employerInnerAccountdetail.yes'),
        text: t('employerInnerAccountdetail.activateJobConfirmTxt'),
        title: t('employerInnerAccountdetail.activateJobConfirmTitle'),
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/job/activate/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              token: tokenKey,
              contentType: 'application/json',
            },
          },
        );

        getData();

        if (response.data.status === 200) {
          resultInfo('success', t('employerInnerAccountdetail.activateJobSuccessTitle'), t('employerInnerAccountdetail.close')); // eslint-disable-line
        } else if (response.data.status === 400) {
          navigate('/');

          Cookies.remove('fname');
          Cookies.remove('user_id');
          Cookies.remove('user_type');
          Cookies.remove('tokenClient');

          resultInfo('warning', response.data.message, t('employerInnerAccountdetail.close'));
        } else {
          Swal.fire({
            icon: 'error',
            text: response.data.message,
            confirmButtonText: t('employerInnerAccountdetail.close'),
            title: t('employerFavouriteListProfile.addFavFailedTitle'),
          });
        }
      }
    } catch (error) {
      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        resultInfo('error', t('employerInnerAccountdetail.activateJobFailedTitle'), t('employerInnerAccountdetail.close')); // eslint-disable-line
      }

      console.error('Error activating job:', error);
    }
  };

  const handleDeactivate = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: t('employerInnerAccountdetail.no'),
        confirmButtonText: t('employerInnerAccountdetail.yes'),
        text: t('employerInnerAccountdetail.deactivateJobConfirmTxt'),
        title: t('employerInnerAccountdetail.deactivateJobConfirmTitle'),
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/job/deactivate/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              token: tokenKey,
              contentType: 'application/json',
            },
          },
        );

        if (response.data.status === 200) {
          resultInfo('success', t('employerInnerAccountdetail.deactivateJobSuccessTitle'), t('employerInnerAccountdetail.close')); // eslint-disable-line
        } else if (response.data.status === 400) {
          navigate('/');

          Cookies.remove('fname');
          Cookies.remove('user_id');
          Cookies.remove('user_type');
          Cookies.remove('tokenClient');

          resultInfo('warning', response.data.message, t('employerInnerAccountdetail.close'));
        } else {
          Swal.fire({
            icon: 'error',
            text: response.data.message,
            confirmButtonText: t('employerInnerAccountdetail.close'),
            title: t('employerFavouriteListProfile.addFavFailedTitle'),
          });
        }

        getData();
      }
    } catch (error) {
      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        resultInfo('error', t('employerInnerAccountdetail.deactivateJobFailedTitle'), t('employerInnerAccountdetail.close')); // eslint-disable-line
      }

      console.error('Error deactivating job:', error);
    }
  };

  const handleFileDownload = async (e, id) => {
    e.preventDefault();

    try {
      const response = await axios.get(
        BaseApi + `/jobApply/downloadFile/${id}`,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
          },
          responseType: 'blob',
        },
      );

      const url = window.URL.createObjectURL(response.data);
      const filename = response.headers['content-disposition'].split('filename=')[1];

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename.replace(/['"]/g, ''));
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      getData();
    } catch (error) {
      console.error('Could not download file:', error);

      Swal.fire({
        icon: 'error',
        confirmButtonText: t('employerInnerAccountdetail.close'),
        title: t('employerFavouriteListProfile.fileDownloadFailedTitle'),
      });
    }
  };

  useEffect(() => {
    if (userType === 'candidate' || !tokenKey) {
      navigate('/user/employerlogin');
    } else {
      getData();
      // window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  return (
    <>
      <NavBar />
      {
        loading
          ? (
            <div className='loader-container'></div>
          ) : (
            <>
              <div className='container IADsecondSegment'>
                <div className='row'>
                  <div className='col-lg-3 col-md-3 mt-4'>
                    <Sidebar />
                  </div>
                  <div className='col-lg-9 col-md-9 mb-5 IADMainBx'>
                    <section className='MyProfileTopSection'>
                      <div className='MYProfileHeader'>
                        <div className='MyProfileDetails'>
                          <h6 className='mb-2'>
                            {t('employerInnerAccountdetail.user')}{': '}
                            <span className='fw-bold'>
                              {userDetail.first_name} {userDetail.last_name}
                            </span>
                          </h6>
                          <h6 className='mb-4'>
                            {t('employerInnerAccountdetail.companyName')}{': '}
                            <span className='fw-bold'>
                              {jobDetail.company_name}
                            </span>
                          </h6>
                          <h6>
                            {t('employerInnerAccountdetail.activePlan')}{' '}
                            <span className='fw-bold'>
                              {accDetail.planDetails}
                            </span>
                          </h6>
                        </div>
                        <Link to='/plans/purchase' class='btn button1 mt-4 mt-sm-0'>
                          {t('employerInnerAccountdetail.upgradePlan')}
                        </Link>
                      </div>
                    </section>
                    <div className='JobseekerProfileBx'>
                      <div className='JobseekerProfileTopBx'>
                        <h3>
                          <span>{jobDetail.title}</span>
                        </h3>
                        <span className='EditJobseekerProfileTag'>
                          <Link to={`/job/edit/${jobDetail.slug}`}>
                            <i className='fa fa-pencil' aria-hidden='true'></i>{' '}
                            {width >= 768 && t('employerInnerAccountdetail.edit')}
                          </Link>
                          <Link to={`/jobs/createJob/${jobDetail.slug}`}>
                            <i className='fa fa-file-o' aria-hidden='true'></i>{' '}
                            {width >= 768 && t('employerInnerAccountdetail.copy')}
                          </Link>
                          <Link to={`/jobdescription/${jobDetail.slug}/${jobDetail.cat_slug}`}>
                            <i className='fa fa-eye' aria-hidden='true'></i>{' '}
                            {width >= 768 && t('employerInnerAccountdetail.view')}
                          </Link>
                          <Link onClick={() => handleDelete(jobDetail.slug)}>
                            <button disabled>
                              <i className='fa fa-trash' aria-hidden='true'></i>{' '}
                              {width >= 768 && t('employerInnerAccountdetail.archivate')}
                            </button>
                          </Link>
                        </span>
                      </div>
                      <div className='JobseekerProfileDetails'>
                        <div className='JobseekerProfileDetailsBox'>
                          <div className='JobseekerProfileActive manageJobActionButton'>
                            <div className='CreatedDate'>
                              {t('employerInnerAccountdetail.created')}
                              {' '}
                              <strong>{jobDetail?.created}</strong>
                            </div>
                            {
                              jobDetail?.status === 1
                                ? (
                                  <button className='btn-primary' onClick={() => handleDeactivate(jobDetail?.slug)}>
                                    <Tooltip title={t('employerInnerAccountdetail.deactivate')}>
                                      <CheckIcon />
                                    </Tooltip>
                                  </button>
                                ) : (
                                  <button className='btn-secondary' onClick={() => handleActivate(jobDetail?.slug)}>
                                    <Tooltip title={t('employerInnerAccountdetail.activate')}>
                                      <BlockIcon />
                                    </Tooltip>
                                  </button>
                                )
                            }
                          </div>
                        </div>
                        <div className='JobseekerProfileSearch'>
                          <div className='Calcultn'>
                            <h4>{jobDetail?.search_count}</h4>
                            <h6>
                              <span>
                                <i className='fa fa-search icon_calcultn' />{' '}
                              </span>
                              {t('employerInnerAccountdetail.searchViews')}
                            </h6>
                          </div>
                          <div className='Calcultn'>
                            <h4>{jobDetail?.view_count}</h4>
                            <h6>
                              <span>
                                <i className='fa fa-suitcase icon_calcultn' />{' '}
                              </span>
                              {t('employerInnerAccountdetail.jobViews')}
                            </h6>
                          </div>
                          <div className='Calcultn'>
                            <h4>{accDetail?.job_seekers?.totalCandidate}</h4>
                            <h6>
                              <span>
                                <i className='fa-solid fa-clipboard-check' />{' '}
                              </span>
                              {t('employerInnerAccountdetail.applied')}
                            </h6>
                          </div>
                        </div>
                        <div className='JobseekersTabsBx'>
                          <ul className='nav JobseekersTabs' id='myTab' role='tablist'>
                            <li className='nav-item' role='presentation'>
                              <button
                                role='tab'
                                type='button'
                                id='jobseekers-tab'
                                aria-selected='true'
                                data-bs-toggle='tab'
                                className='nav-link active'
                                aria-controls='jobseekers-tab-pane'
                                data-bs-target='#jobseekers-tab-pane'
                              >
                                {t('employerInnerAccountdetail.applied')}
                              </button>
                            </li>
                            <li className='nav-item' role='presentation'>
                              <button
                                role='tab'
                                type='button'
                                id='jobdetails-tab'
                                className='nav-link'
                                data-bs-toggle='tab'
                                aria-selected='false'
                                aria-controls='jobdetails-tab-pane'
                                data-bs-target='#jobdetails-tab-pane'
                              >
                                {t('employerInnerAccountdetail.jobDetails')}
                              </button>
                            </li>
                          </ul>
                          <div className='tab-content' id='myTabContent'>
                            <div
                              tabIndex='0'
                              role='tabpanel'
                              id='jobseekers-tab-pane'
                              aria-labelledby='jobseekers-tab'
                              className='tab-pane fade show active'
                            >
                              <div className='JobseekersTabsContent'>
                                <div className='JobseekersContentTop'>
                                  <ul>
                                    <li>
                                      <h4>{accDetail?.job_seekers?.totalCandidate}</h4>
                                      <h6>
                                        {t('employerInnerAccountdetail.total')}
                                      </h6>
                                    </li>
                                    <li>
                                      <h4>{accDetail?.job_seekers?.new}</h4>
                                      <h6>
                                        {t('employerInnerAccountdetail.new')}
                                      </h6>
                                    </li>
                                    <li>
                                      <h4>{accDetail?.job_seekers?.reviewed}</h4>
                                      <h6>
                                        {t('employerInnerAccountdetail.reviewed')}
                                      </h6>
                                    </li>
                                    <li>
                                      <h4>{accDetail?.job_seekers?.shortList}</h4>
                                      <h6>
                                        {t('employerInnerAccountdetail.shortlist')}
                                      </h6>
                                    </li>
                                    <li>
                                      <h4>{accDetail?.job_seekers?.interview}</h4>
                                      <h6>
                                        {t('employerInnerAccountdetail.interview')}
                                      </h6>
                                    </li>
                                    <li>
                                      <h4>{accDetail?.job_seekers?.offer}</h4>
                                      <h6>
                                        {t('employerInnerAccountdetail.offer')}
                                      </h6>
                                    </li>
                                    <li>
                                      <h4>{accDetail?.job_seekers?.accept}</h4>
                                      <h6>
                                        {t('employerInnerAccountdetail.accept')}
                                      </h6>
                                    </li>
                                    <li>
                                      <h4>{accDetail?.job_seekers?.notSuitable}</h4>
                                      <h6>
                                        {t('employerInnerAccountdetail.notSuitable')}
                                      </h6>
                                    </li>
                                  </ul>
                                </div>
                                {
                                  !sendMail && (
                                    <div className='JobseekersSearchContent'>
                                      <div className='no_found'>
                                        <div className='tableBox'>
                                          <div className='tableHeader'>
                                            <div className='leftSide'>
                                              <input
                                                name='global'
                                                type='checkbox'
                                                onClick={handleGlobalCheckboxChange}
                                              />
                                              <p>{t('employerInnerAccountdetail.name')}</p>
                                            </div>
                                            <div className='rightSide'>
                                              <div className='appliedDate'>{t('employerInnerAccountdetail.date')}</div>
                                              <div className='rating'>{t('employerInnerAccountdetail.rating')}</div>
                                              <div className='statusSelect'>{t('employerInnerAccountdetail.status')}</div>
                                              <div className='jobApplyType'>{t('employerInnerAccountdetail.type')}</div>
                                            </div>
                                          </div>
                                          <div className='tableBody'>
                                            {
                                              candidates.map(i => (
                                                <div className='tableItem' key={i.slug}>
                                                  <div className='leftSide'>
                                                    <input
                                                      type='checkbox'
                                                      name='individual'
                                                      checked={selectedEmails.includes(i.email_address)}
                                                      onChange={() => handleCheckboxChange(i.email_address)}
                                                    />
                                                    <div className='usernameInnerAccDetails'>
                                                      <p>{i.name}</p>
                                                      {
                                                        i.coverletter.description && (
                                                          <Link onClick={() => handleOpenCoverModal(i.coverletter)}>
                                                            <i className='fa-solid fa-envelope'></i>{' '}
                                                            {t('employerInnerAccountdetail.coverLetter')}
                                                          </Link>
                                                        )
                                                      }
                                                    </div>
                                                  </div>
                                                  <div className='rightSide'>
                                                    <div className='appliedDate'>
                                                      {i.created}
                                                    </div>
                                                    <div className='rating'>
                                                      {renderStars(i.rating, i.job_apply_id)}
                                                    </div>
                                                    <select
                                                      value={i.apply_status}
                                                      aria-label='Default select example'
                                                      className='form-select selectFormInnerAccDetails statusSelect'
                                                      onChange={e => handleStatusChange(i.job_apply_id, e.target.value, i.user_id)}
                                                    >
                                                      {
                                                        i.apply_status === 'new' && (
                                                          <option value='new' hidden>{t('employerInnerAccountdetail.newApply')}</option>
                                                        )
                                                      }
                                                      {
                                                        i.apply_status === 'reviewed' && (
                                                          <option value='reviewed' hidden>{t('employerInnerAccountdetail.reviewed')}</option>
                                                        )
                                                      }
                                                      {
                                                        Object.entries(activeOptions).map(([key, value]) => (
                                                          <option key={key} value={key}>
                                                            {value}
                                                          </option>
                                                        ))
                                                      }
                                                    </select>
                                                    <div className='jobApplyType'>
                                                      {
                                                        i.jobApplyType.type === 'cv' && (
                                                          <div>
                                                            <Link to={`/candidates/profile/${i.slug}?cv_id=${i.cv_id}&job_apply_id=${i.job_apply_id}`}>
                                                              <VisibilityIcon sx={{ mr: '6px' }} />
                                                              {t('employerInnerAccountdetail.view')}
                                                            </Link>
                                                            <p>{t('employerInnerAccountdetail.cv')}</p>
                                                          </div>
                                                        )
                                                      }
                                                      {
                                                        i.jobApplyType.type === 'questionary' && (
                                                          <div>
                                                            <Link to={`/candidates/questionnaire/${i.jobApplyType.id}`}>
                                                              <VisibilityIcon sx={{ mr: '6px' }} />
                                                              {t('employerInnerAccountdetail.view')}
                                                            </Link>
                                                            <p>{t('employerInnerAccountdetail.questionnaire')}</p>
                                                          </div>
                                                        )
                                                      }
                                                      {
                                                        i.jobApplyType.type === 'file' && (
                                                          <div>
                                                            <a href='#' onClick={e => handleFileDownload(e, i.jobApplyType.id)}>
                                                              <FileDownloadRoundedIcon sx={{ mr: '6px' }} />
                                                              {t('employerInnerAccountdetail.download')}
                                                            </a>
                                                            <p>{t('employerInnerAccountdetail.file')}</p>
                                                          </div>
                                                        )
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            }
                                          </div>
                                        </div>
                                        {
                                          candidates != '' && selectedEmails?.length > 0 && (
                                            <button
                                              type='button'
                                              onClick={handleSendButton}
                                              className='btn button1 mt-4'
                                            >
                                              {t('employerInnerAccountdetail.sendMailButton')}
                                            </button>
                                          )
                                        }
                                      </div>
                                    </div>
                                  )
                                }
                                {
                                  sendMail && (
                                    <div className='sendMailComponent'>
                                      <div className='no_found'>
                                        <div className='card'>
                                          <div className='sendMailHeader'>
                                            {t('employerInnerAccountdetail.sendMailButton')}
                                          </div>
                                          <div className='form-outline sendMailInputManageJobs DashBoardInputBx'>
                                            <label className='form-label' htmlFor='form3Example3'>
                                              {t('employerInnerAccountdetail.to')}
                                            </label>
                                            <input
                                              disabled
                                              type='text'
                                              id='email_address'
                                              name='email_address'
                                              className='form-control'
                                              value={mailUsers.email_address}
                                              placeholder={t('employerInnerAccountdetail.email')}
                                            />
                                          </div>
                                          <div className='form-outline sendMailInputManageJobs DashBoardInputBx'>
                                            <label className='form-label' htmlFor='form3Example3'>
                                              {t('employerInnerAccountdetail.subject')}{' '}
                                              <span className='RedStar'>*</span>
                                            </label>
                                            <input
                                              type='text'
                                              id='subject'
                                              name='subject'
                                              className='form-control'
                                              value={mailUsers.subject}
                                              onChange={handleMailReplyChange}
                                              placeholder={t('employerInnerAccountdetail.subject')}
                                            />
                                            {
                                              mailReplyError.subject && (
                                                <div className='text-danger'>
                                                  {mailReplyError.subject}
                                                </div>
                                              )
                                            }
                                          </div>
                                          <div className='form-outline sendMailInputManageJobs DashBoardInputBx'>
                                            <label className='form-label' htmlFor='form3Example3'>
                                              {t('employerInnerAccountdetail.message')}{' '}
                                              <span className='RedStar'>*</span>
                                            </label>
                                            <input
                                              type='text'
                                              id='message'
                                              name='message'
                                              className='form-control'
                                              value={mailUsers.message}
                                              onChange={handleMailReplyChange}
                                              placeholder={t('employerInnerAccountdetail.message')}
                                            />
                                            {
                                              mailReplyError.message && (
                                                <div className='text-danger'>
                                                  {mailReplyError.message}
                                                </div>
                                              )
                                            }
                                          </div>
                                          <div className='sendMailManageJobsButtons'>
                                            <button
                                              type='button'
                                              className='btn btn-primary button1'
                                              onClick={() => handleMailReply(jobDetail.slug)}
                                            >
                                              {t('employerInnerAccountdetail.sendButton')}
                                            </button>
                                            <button
                                              type='button'
                                              onClick={handleCancelClick}
                                              className='btn btn-primary button2'
                                            >
                                              {t('employerInnerAccountdetail.cancelButton')}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                }
                              </div>
                            </div>
                            <div
                              tabIndex='0'
                              role='tabpanel'
                              id='jobdetails-tab-pane'
                              className='tab-pane fade '
                              aria-labelledby='jobdetails-tab'
                            >
                              <div className='JobseekersTabsContent'>
                                <div className='JobseekersTabsDetails'>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.vacancyID')}
                                    </label>
                                    <span>
                                      <em>{jobDetail.job_id}</em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.category')}
                                    </label>
                                    <span>
                                      <em>{jobDetail.category}</em>
                                    </span>
                                  </div>
                                  {
                                    jobDetail.subcategory
                                      ? (
                                        <div className='JobseekersTabsDetailsList'>
                                          <label>
                                            {t('employerInnerAccountdetail.subCategory')}
                                          </label>
                                          <span>
                                            <em>{jobDetail.subcategory}</em>
                                          </span>
                                        </div>
                                      )
                                      : ''
                                  }
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.contactName')}
                                    </label>
                                    <span>
                                      <em>{jobDetail.contact_name}</em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.contactNumber')}
                                    </label>
                                    <span>
                                      <em>{jobDetail.contact_number}</em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.skills')}
                                    </label>
                                    <span>
                                      <em>{jobDetail.skill}</em>
                                    </span>
                                  </div>
                                  {
                                    jobDetail.lang_skills && (
                                      <div className='JobseekersTabsDetailsList'>
                                        <label>
                                          {t('employerInnerAccountdetail.additionalLanguages')}
                                        </label>
                                        <span>
                                          <em>{jobDetail.lang_skills[0]}</em>
                                        </span>
                                        {
                                          jobDetail.lang_skills[1] && (
                                            <>
                                              <label>{' '}</label>
                                              <span>
                                                <em>{jobDetail.lang_skills[1]}</em>
                                              </span>
                                            </>
                                          )
                                        }
                                      </div>
                                    )
                                  }
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.location')}
                                    </label>
                                    <span>
                                      <em>{jobDetail.city_region}</em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.workType')}
                                    </label>
                                    <span>
                                      <em>{jobDetail.work_type}</em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList standartListStyle'>
                                    <label>
                                      {t('employerInnerAccountdetail.description')}
                                    </label>
                                    <span>
                                      <em>
                                        {
                                          jobDetail.description
                                            ? HTMLReactParser(jobDetail.description)
                                            : ''
                                        }
                                      </em>
                                      {' '}
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.salary')}
                                    </label>
                                    <span>
                                      <em>
                                        {curr} {jobDetail.salary_min} - {curr}{' '}{jobDetail.salary_max}
                                      </em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.experience')}
                                    </label>
                                    <span>
                                      <em>
                                        {jobDetail.min_exp}-{jobDetail.max_exp}{' '}{t('employerInnerAccountdetail.year')}
                                      </em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.companyName')}
                                    </label>
                                    <span>
                                      <em>{jobDetail.company_name}</em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList standartListStyle'>
                                    <label>
                                      {t('employerInnerAccountdetail.companyProfile')}
                                    </label>
                                    <span>
                                      <em>
                                        {
                                          jobDetail.company_profile
                                            ? HTMLReactParser(jobDetail.company_profile)
                                            : ''
                                        }
                                      </em>
                                    </span>
                                  </div>
                                  <div className='JobseekersTabsDetailsList'>
                                    <label>
                                      {t('employerInnerAccountdetail.companyWebsite')}
                                    </label>
                                    <span>
                                      <em>
                                        <a href={jobDetail.url} target='blank'>
                                          {jobDetail.url}
                                        </a>
                                      </em>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <Modal
                    open={openCoverModal}
                    onClose={handleCloseCoverModal}
                    className='modalMain standartListStyle'
                  >
                    <Box
                      className='modal adminModal modal-content'
                      sx={{
                        width: '100%',
                        maxWidth: '700px',
                        maxHeight: '500px',
                      }}
                    >
                      <IconButton
                        onClick={handleCloseCoverModal}
                        className='close-button'
                        style={{
                          top: '10px',
                          right: '20px',
                          position: 'absolute',
                        }}
                      >
                        &times;
                      </IconButton>
                      <Box
                        sx={{
                          p: '20px',
                          width: '100%',
                          borderRadius: '5px',
                        }}
                      >
                        <div className='modals'>
                          <div className='modalHead text-center'>
                            <h3>{t('employerInnerAccountdetail.coverLetter')}</h3>
                          </div>
                          <div className='modalBody mt-4'>
                            <div className='modalBody mt-4'>
                              {
                                selectedPayment && (
                                  <>
                                    <div className='mb-2'>
                                      {selectedPayment.title}
                                    </div>
                                    <div>
                                      {selectedPayment.description}
                                    </div>
                                  </>
                                )
                              }
                            </div>
                          </div>
                        </div>
                      </Box>
                    </Box>
                  </Modal>
                </div>
              </div>
              <Footer />
            </>
          )
      }
    </>
  );
};

export default InnerAccountdetail;
